import actions from './actions';

const {
  LIST_EMPRESAS,
  LIST_EMPRESAS_SELECTBOX,
  CREATE_EMPRESAS,
  READ_EMPRESAS,
  UPDATE_EMPRESAS,    
} = actions;

const initialState = {
  data: [],
  dataSelectBox: [],
  record: {},   
};


const empresasCrudReducer = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case LIST_EMPRESAS:
      return {
        ...state,
        data: data
      }
    case LIST_EMPRESAS_SELECTBOX:
      return {
        ...state,
        dataSelectBox: data
      }
    case CREATE_EMPRESAS:
      return {
        ...state,
        record: data
      }
    case READ_EMPRESAS:
      return {
        ...state,
        record: data
      }
    case UPDATE_EMPRESAS:
      return {
        ...state,
        record: data
      }
    default:
      return state;
  }
};


export default empresasCrudReducer;
